var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/social/spotify.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg width=\"1000\" height=\"1000\" viewBox=\"0 0 1000 1000\" class=\"c-social__spotify\" aria-labelledby=\"spotify-svg-title\" xmlns=\"http://www.w3.org/2000/svg\">\n    <title id=\"spotify-svg-title\">\n        ";
output += runtime.suppressValue((lineno = 2, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["social-spotify"])), env.opts.autoescape);
output += "\n    </title>\n    <path d=\"M0 500q0-136 67-251t182-182 251-67 251 67 182 182 67 251q0 101-38 192t-107 160q-60-73-145.5-114t-182.5-41q-107 0-199 49.5t-151 134.5q-83-71-130-170t-47-211zm164-144q0 17 12 29.5t30 12.5q6 0 9-1 144-58 298-58t298 58q1 0 4 .5t5 .5q17 0 29.5-12.5t12.5-29.5q0-25-23-37-159-63-326-63-170 0-329 64-20 13-20 36zm46 149l6 16q8 13 23 13 3 0 9-2 127-55 265-55 139 0 267 56 4 2 7 2 15 0 23-13l5-17q0-13-10-21-138-62-292-62-153 0-293 62-10 10-10 21zm48 144q10 25 31 16 108-51 224-51 112 0 219 48 24 13 35-12 5-13 0-23t-14-15q-106-53-240-53-128 0-244 55-19 10-11 35zm61 317q37-48 91.5-76t116.5-28q114 0 193 86-104 52-220 52-94 0-181-34z\"></path>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/social/spotify.j2"] , dependencies)